import React, { useEffect, useState } from "react";
import {
  CCard,
  CCardBody,
  CCardHeader,
  CButton,
  CRow,
  CCol,
  CTable,
  CTableHead,
  CTableRow,
  CTableHeaderCell,
  CTableBody,
  CTableDataCell,
  CFormSelect,
  CFormInput,
  CModal,
} from "@coreui/react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchOrders,
  fetchReverseBidOrders,
  fetchShippingPartners,
  updateOrderStatus,
  updateShippingPartner,
  updateTrackingNumber,
} from "../../features/seller/sellerSlice";
import AppLoader from "../../components/seller/AppLoader";
import { capitalizeFirst } from "../../utils/stringUtils";
import { timeAgo } from "../../utils/timeAgo";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import AppToast from "../../components/seller/AppToast";
import "./styles.css";
import { formatCurrency, formatPrice } from "../../utils/price";

import { useNavigate } from "react-router-dom";

const trackingValidationSchema = Yup.object({
  trackingInput: Yup.string().required("Tracking number is required"),
});

const RequestedBidOrders = () => {
  const dispatch = useDispatch();
  const { list: reverseBidOrders = [], loading: reverseBidLoading } =
    useSelector((state) => state.seller.reverseBids);

  const shipping = useSelector((state) => state.seller.shipping.partners);
  console.log("reverseBidOrders:", reverseBidOrders);

  const [search, setSearch] = useState("");
  const [entriesPerPage, setEntriesPerPage] = useState(5);
  const [currentPage, setCurrentPage] = useState(1);
  const [visibleModal, setVisibleModal] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [trackingInput, setTrackingInput] = useState("");
  // const [page, setPage] = useState(1);
  const [toastVisible, setToastVisible] = useState(false);
  const [toastType, setToastType] = useState("info");
  const [toastMessage, setToastMessage] = useState("");
  // console.log("Order list:", orders);
  // console.log("Current page:", currentPage);
  // console.log("Last page:", lastPage);
  // console.log("Shipping:", shipping);

  useEffect(() => {
    dispatch(fetchReverseBidOrders())
      .unwrap()
      .catch((err) => {
        console.error("Failed to load orders:", err);
      });
  }, [dispatch]);

  useEffect(() => {
    dispatch(fetchShippingPartners())
      .unwrap()
      .catch((err) => {
        console.error("Failed to load shipping partners:", err);
      });
  }, [dispatch]);

  const filtered = search
    ? reverseBidOrders.filter((o) =>
        o.requirement?.scrap_type?.toLowerCase().includes(search.toLowerCase())
      )
    : reverseBidOrders;

  const indexOfLast = currentPage * entriesPerPage;
  const indexOfFirst = indexOfLast - entriesPerPage;
  const currentData = filtered.slice(indexOfFirst, indexOfLast);
  const totalPages = Math.ceil(filtered.length / entriesPerPage);

  // console.log("Data:", reverseBidOrders);

  const handleOpenModal = (order) => {
    setSelectedOrder(order);
    setTrackingInput(order.trackingNumber || "");
    setVisibleModal(true);
  };

  // console.log("selectedOrder.id", selectedOrder ? selectedOrder.id : null);
  const handleUpdateTracking = async (trackingNumber) => {
    if (!selectedOrder) return;
    try {
      const res = await dispatch(
        updateTrackingNumber({
          tracking_number: trackingNumber,
          order_id: selectedOrder.id,
        })
      ).unwrap();
      setVisibleModal(false);
      dispatch(fetchOrders({ page: currentPage }));

      setToastType("success");
      setToastMessage(res?.message || "Tracking number updated successfully.");
      setToastVisible(true);
    } catch (err) {
      console.error("Failed to update tracking:", err);
      setToastType("error");
      setToastMessage(err?.message || "Failed to update tracking number.");
      setToastVisible(true);
    }
  };

  const handleUpdateShippingPartner = async (orderId, partnerId) => {
    // console.log("partnerId:", partnerId);
    try {
      const res = await dispatch(
        updateShippingPartner({
          id: orderId,
          data: { shipping_partner_id: partnerId },
        })
      ).unwrap();
      dispatch(fetchOrders({ page: currentPage }));

      setToastType("success");
      setToastMessage(res?.message || "Shipping partner updated successfully.");
      setToastVisible(true);
    } catch (err) {
      console.error("Failed to update shipping partner", err);
      setToastType("error");
      setToastMessage(err?.message || "Failed to update shipping partner.");
      setToastVisible(true);
    }
  };

  const handleUpdateOrderStatus = async (orderId, status) => {
    try {
      const res = await dispatch(
        updateOrderStatus({
          id: orderId,
          data: { status },
        })
      ).unwrap();
      dispatch(fetchOrders({ page: currentPage }));

      setToastType("success");
      setToastMessage(res?.message || "Order status updated successfully.");
      setToastVisible(true);
    } catch (err) {
      console.error("Failed to update order status", err);
      setToastType("error");
      setToastMessage(err?.message || "Failed to update order status.");
      setToastVisible(true);
    }
  };

  // Navigation hook for row click offer detail
  const navigate = useNavigate();

  const handleRowClick = (orderId) => {
    navigate(`/seller/order-detail/${orderId}`);
  };

  if (reverseBidLoading) {
    return <AppLoader />;
  }
  return (
    <>
      <div className="container-fluid px-3">
        <CRow className="mt-4 mb-3">
          <CCol>
            <h4 className="mb-0">Received Orders</h4>
          </CCol>
        </CRow>

        <CCard>
          <CCardHeader>
            <CRow className="mb-2">
              <CCol>
                <h6
                  className="text-muted mb-0 d-flex align-items-center"
                  style={{ height: "100%" }}
                >
                  Orders placed by buyers
                </h6>
              </CCol>
            </CRow>

            <hr className="my-2" />
            <CRow className="align-items-center">
              <CCol md={6}>
                Show{" "}
                <CFormSelect
                  size="sm"
                  value={entriesPerPage}
                  onChange={(e) => setEntriesPerPage(Number(e.target.value))}
                  style={{ display: "inline-block", width: "auto" }}
                  options={[
                    { label: "5", value: "5" },
                    { label: "10", value: "10" },
                    { label: "25", value: "25" },
                  ]}
                />{" "}
                entries
              </CCol>
              <CCol md={6} className="text-end">
                Search:{" "}
                <CFormInput
                  type="text"
                  size="sm"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  style={{ display: "inline-block", width: "200px" }}
                />
              </CCol>
            </CRow>
          </CCardHeader>

          <CCardBody>
            {/* <div className="custom-scrollbar"> */}
            <CTable responsive bordered hover>
              <CTableHead color="light">
                <CTableRow>
                  <CTableHeaderCell>#</CTableHeaderCell>
                  <CTableHeaderCell>Order ID</CTableHeaderCell>
                  <CTableHeaderCell>Buyer</CTableHeaderCell>
                  <CTableHeaderCell>Scrape Type</CTableHeaderCell>
                  <CTableHeaderCell>Category</CTableHeaderCell>
                  <CTableHeaderCell>Sub Category</CTableHeaderCell>
                  <CTableHeaderCell>Quantity</CTableHeaderCell>
                  <CTableHeaderCell>Unit</CTableHeaderCell>
                  <CTableHeaderCell>Total Price (AUD)</CTableHeaderCell>
                  <CTableHeaderCell>Payment</CTableHeaderCell>
                  <CTableHeaderCell>Date</CTableHeaderCell>
                  <CTableHeaderCell>Shipping Partner</CTableHeaderCell>
                  <CTableHeaderCell>Status</CTableHeaderCell>
                  <CTableHeaderCell>Tracking</CTableHeaderCell>
                  <CTableHeaderCell>Action</CTableHeaderCell>
                </CTableRow>
              </CTableHead>
              <CTableBody>
                {currentData.map((order, index) => (
                  <CTableRow
                    key={order.id}
                    style={{ cursor: "pointer" }}
                    onClick={() => handleRowClick(order.id)}
                  >
                    <CTableDataCell>{index + 1}</CTableDataCell>
                    <CTableDataCell>
                      {order.unique_order_id || "-"}
                    </CTableDataCell>
                    <CTableDataCell>{order.buyer?.name || "-"}</CTableDataCell>
                    <CTableDataCell>
                      {order.requirement?.scrap_type || "-"}
                    </CTableDataCell>
                    <CTableDataCell>
                      {order.requirement?.category?.name || "-"}
                    </CTableDataCell>
                    <CTableDataCell>
                      {order.requirement?.subcategory?.name || "-"}
                    </CTableDataCell>
                    <CTableDataCell>
                      {order.requirement?.quantity != null
                        ? order.requirement.quantity
                        : "-"}
                    </CTableDataCell>
                    <CTableDataCell>
                      {order.requirement?.unit || "-"}
                    </CTableDataCell>
                    <CTableDataCell>
                      {formatCurrency(order.total_price)}
                      {/* {order.total_price != null
                        ? `A$ ${formatPrice(order.total_price)}`
                        : "-"} */}
                    </CTableDataCell>
                    <CTableDataCell>
                      {order.payment_status
                        ? capitalizeFirst(order.payment_status)
                        : "-"}
                    </CTableDataCell>
                    <CTableDataCell>
                      {order.created_at ? timeAgo(order.created_at) : "-"}
                    </CTableDataCell>
                    <CTableDataCell>
                      <CFormSelect
                        size="sm"
                        value={order.shipping_partner_id || ""}
                        onChange={(e) =>
                          handleUpdateShippingPartner(order.id, e.target.value)
                        }
                      >
                        <option value="">Select</option>
                        {shipping &&
                          shipping.map((partner) => (
                            <option key={partner.id} value={partner.id}>
                              {partner.name}
                            </option>
                          ))}
                      </CFormSelect>
                    </CTableDataCell>
                    <CTableDataCell>
                      <span
                        className={`badge bg-${
                          order.status === "completed"
                            ? "success"
                            : order.status === "pending"
                            ? "warning"
                            : order.status === "rejected"
                            ? "danger"
                            : order.status === "matched" ||
                              order.status === "accepted"
                            ? "info"
                            : "secondary"
                        }`}
                      >
                        {order.status ? capitalizeFirst(order.status) : "-"}
                      </span>
                    </CTableDataCell>
                    <CTableDataCell>
                      <CButton
                        size="sm"
                        color="dark"
                        disabled={
                          order.status !== "accepted" &&
                          order.status !== "shipped"
                        }
                        onClick={(e) => {
                          e.stopPropagation();
                          handleOpenModal(order);
                        }}
                      >
                        Update
                      </CButton>
                    </CTableDataCell>
                    <CTableDataCell style={{ minWidth: "140px" }}>
                      <CFormSelect
                        size="sm"
                        value={order.status || ""}
                        onMouseDown={(e) => e.stopPropagation()}
                        onClick={(e) => e.stopPropagation()}
                        onChange={(e) => {
                          e.stopPropagation();
                          handleUpdateOrderStatus(order.id, e.target.value);
                        }}
                      >
                        <option value="pending">Pending</option>
                        <option value="matched">Matched</option>
                        <option value="accepted">Accepted</option>
                        <option value="shipped">Shipped</option>
                        <option value="completed">Completed</option>
                        <option value="delivered">Delivered</option>
                        <option value="rejected">Rejected</option>
                      </CFormSelect>
                    </CTableDataCell>
                  </CTableRow>
                ))}
                {currentData.length === 0 && (
                  <CTableRow>
                    <CTableDataCell
                      colSpan="14"
                      className="text-center text-muted"
                    >
                      No Requested bid orders found.
                    </CTableDataCell>
                  </CTableRow>
                )}
              </CTableBody>
            </CTable>
            {/* </div> */}

            <div className="d-flex justify-content-between align-items-center mt-3">
              <div>
                Showing {indexOfFirst + 1} to{" "}
                {Math.min(indexOfLast, filtered.length)} of {filtered.length}{" "}
                entries
              </div>
              <div className="d-flex align-items-center">
                <CButton
                  size="sm"
                  color="light"
                  disabled={currentPage === 1}
                  onClick={() => setCurrentPage(currentPage - 1)}
                  className="me-2"
                >
                  Prev
                </CButton>

                {[...Array(totalPages)].map((_, i) => (
                  <CButton
                    key={i}
                    size="sm"
                    color={currentPage === i + 1 ? "primary" : "light"}
                    onClick={() => setCurrentPage(i + 1)}
                    className="me-2"
                  >
                    {i + 1}
                  </CButton>
                ))}

                <CButton
                  size="sm"
                  color="light"
                  disabled={currentPage === totalPages}
                  onClick={() => setCurrentPage(currentPage + 1)}
                >
                  Next
                </CButton>
              </div>
            </div>
          </CCardBody>
        </CCard>

        {/* Tracking Number Modal */}
        <CModal
          visible={visibleModal}
          onClose={() => setVisibleModal(false)}
          alignment="center"
        >
          {selectedOrder && (
            <CCard className="m-0">
              <CCardBody>
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <h5 className="mb-0">Update Tracking Number</h5>
                  <CButton
                    color="light"
                    className="p-0"
                    onClick={() => setVisibleModal(false)}
                  >
                    <span aria-hidden="true">&times;</span>
                  </CButton>
                </div>
                <Formik
                  initialValues={{ trackingInput: trackingInput || "" }}
                  validationSchema={trackingValidationSchema}
                  onSubmit={(values, { setSubmitting }) => {
                    handleUpdateTracking(values.trackingInput);
                    setSubmitting(false);
                  }}
                  enableReinitialize
                >
                  {({
                    values,
                    setFieldValue,
                    handleBlur,
                    touched,
                    errors,
                    isSubmitting,
                  }) => (
                    <Form>
                      <CFormInput
                        label="Tracking Number"
                        name="trackingInput"
                        value={values.trackingInput}
                        onChange={(e) =>
                          setFieldValue("trackingInput", e.target.value)
                        }
                        onBlur={handleBlur}
                        placeholder="Enter tracking number"
                      />
                      {touched.trackingInput && errors.trackingInput && (
                        <div className="text-danger">
                          {errors.trackingInput}
                        </div>
                      )}
                      <div className="d-flex justify-content-end mt-4">
                        <CButton
                          color="primary"
                          className="me-2"
                          type="submit"
                          disabled={isSubmitting}
                        >
                          Save
                        </CButton>
                        <CButton
                          color="secondary"
                          onClick={() => setVisibleModal(false)}
                        >
                          Cancel
                        </CButton>
                      </div>
                    </Form>
                  )}
                </Formik>
              </CCardBody>
            </CCard>
          )}
        </CModal>
      </div>
      <AppToast
        visible={toastVisible}
        setVisible={setToastVisible}
        type={toastType}
        message={toastMessage}
      />
    </>
  );
};

export default RequestedBidOrders;
